import { render, staticRenderFns } from "./MoneyFilterSummary.vue?vue&type=template&id=58dd596e&scoped=true"
import script from "./MoneyFilterSummary.vue?vue&type=script&lang=js"
export * from "./MoneyFilterSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58dd596e",
  null
  
)

export default component.exports